import axios from "../javascript/custom-axios";
let RESOURCE_NAME = "announcament";

export default {
  /**
   * Add An Announcement.
   * @param {{ CustomerCompanyIds: string[], Title: string, Description: string, FileUrl: string }} body
   * @returns {Promise<any>}
   */
  add(body) {
    return axios.post(`${RESOURCE_NAME}/add`, body);
  },

  /**
   * Update An Announcement.
   * @param {{ Id: string, CustomerCompanyIds: string[], Title: string, Description: string, FileUrl: string }} body
   * @returns {Promise<any>}
   */
  update(body) {
    return axios.put(`${RESOURCE_NAME}/update`, body);
  },

  /**
   * Mark an announcement as read.
   * @param {{ Id: string, IsRead: boolean }} body
   * @returns {Promise<any>}
   */
  markAsRead(body) {
    return axios.put(`${RESOURCE_NAME}/markAsRead`, body);
  },

  /**
   * Delete an announcement.
   * @param {{ Id: string } params
   * @returns {Promise<any>}
   */
  delete(params) {
    return axios.delete(`${RESOURCE_NAME}/delete`, {
      data: params,
    });
  },

  /**
   * Get announcement list.
   * @param {{ Page: number, PageSize: number }} params
   * @returns {Promise<any>}
   */
  getAnnouncements(params) {
    return axios.get(`${RESOURCE_NAME}/get`, {
      params,
    });
  },

    /**
   * Get announcement list for supplier.
   * @param {{ Page: number, PageSize: number }} params
   * @returns {Promise<any>}
   */
    getAnnouncementsForSupplier(params) {
      return axios.get(`${RESOURCE_NAME}/getForSupplier`, {
        params,
      });
    },

   /**
   * Get company list for announcements.
   * @returns {Promise<any>}
   */
   getCompaniesForAnnouncements(params) {
    return axios.get(`${RESOURCE_NAME}/getCompanies`);
  },
};
